module.exports = __webpack_public_path__ + "static/media/intro-audio.07a631cc.mp3";